import { render, staticRenderFns } from "./IndicacaoView.vue?vue&type=template&id=362f858a&"
import script from "./IndicacaoView.vue?vue&type=script&lang=js&"
export * from "./IndicacaoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports